// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { PatientAccountIsPatientRegisteredIPatientRegistrationData } from './patientAccountIsPatientRegisteredIPatientRegistrationData.js';
import type { Moment } from 'moment';
import type { IAttributeTypeMap, RequestFile } from '@trialcard/shared';

export class PatientAccountIsPatientRegisteredPatientAccountIsPatientRegisteredDefaultResponse {
    'success': boolean;
    'messages': Array<string>;
    'data': PatientAccountIsPatientRegisteredIPatientRegistrationData | null;

    static readonly discriminator: string | undefined = undefined;

    static readonly additionalProperties = false;

    
    static readonly attributeTypeMap: ReadonlyArray<IAttributeTypeMap<keyof PatientAccountIsPatientRegisteredPatientAccountIsPatientRegisteredDefaultResponse>> = [
        {
            "name":     "success",
            "baseName": "success",
            "type":     "boolean"
        },
        {
            "name":     "messages",
            "baseName": "messages",
            "type":     "Array<string>"
        },
        {
            "name":     "data",
            "baseName": "data",
            "type":     "PatientAccountIsPatientRegisteredIPatientRegistrationData"
        },
    ];

    static getAttributeTypeMap() {
        return PatientAccountIsPatientRegisteredPatientAccountIsPatientRegisteredDefaultResponse.attributeTypeMap;
    }
}
